import { render, staticRenderFns } from "./EntityFormConfigModal.vue?vue&type=template&id=967c3e10&"
import script from "./EntityFormConfigModal.vue?vue&type=script&lang=js&"
export * from "./EntityFormConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports